import './App.css';
import Main from './components/main';
import Header from './components/header';
import ContactForm from './components/ContactForm';
import Footer from './components/footer';
import React from 'react';
import { useDarkMode } from './hooks/useDarkMode';

const App: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <div className="App">
      <button className="dark-mode-toggle" onClick={toggleDarkMode} title="Toggle dark mode">
        {isDarkMode ? '☀️' : '🌙'}
      </button>
      <Header />
      <Main />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default App;
